import { useEffect } from "react";
import { bankExtraParams } from "../../../constants/bankExtraParams";
import FormInput from "../FormElements/FormInput";

type ExtraParamProps = {
    bankId:  5 | 6 | 7 | 10,
    extraParams: boolean,
    values: string
}

export const ExtraParams: React.FC<ExtraParamProps> = ({
    bankId,
    extraParams,
    values
}) => {
    if (!extraParams || !bankExtraParams[bankId]) return null;

    return (
        <div className="grid grid-cols-1 gap-x-4 sm:gap-6 lg:grid-cols-4 xl:grid-cols-4 mt-3">
            {bankExtraParams[bankId].map((field: any, index: number) => (
                
                <div key={index} className="col-span-2 mt-2 space-y-2">
                    <FormInput
                        label={field.label}
                        name={field.name}
                        type={field.type}
                        value={values[field.name]}
                    />
                </div>
            ))}
        </div>
    );
};
